const TOKEN_KEY = 'allocatiq-auth-token'

const getBaseUrl = () =>
 // import.meta.env.VITE_API_BASE_URL || 'http://localhost:3001'
 import.meta.env.VITE_API_BASE_URL || '/api'

function getToken(): string | null {
  return localStorage.getItem(TOKEN_KEY)
}

function setToken(token: string): void {
  localStorage.setItem(TOKEN_KEY, token)
}

function clearToken(): void {
  localStorage.removeItem(TOKEN_KEY)
}

async function request<T>(method: string, path: string, body?: unknown): Promise<T> {
  const token = getToken()
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
  }
  if (token) {
    headers['Authorization'] = `Bearer ${token}`
  }

  const response = await fetch(`${getBaseUrl()}${path}`, {
    method,
    headers,
    body: body !== undefined ? JSON.stringify(body) : undefined,
  })

  if (!response.ok) {
    const errorBody = await response.json().catch(() => ({ message: response.statusText }))
    const error = new Error(errorBody?.message || `Request failed: ${response.status}`)
    ;(error as any).status = response.status
    throw error
  }

  if (response.status === 204) {
    return undefined as T
  }

  const text = await response.text()
  if (!text) {
    return undefined as T
  }

  return JSON.parse(text) as T
}

export const apiClient = {
  getToken,
  setToken,
  clearToken,
  get<T>(path: string): Promise<T> { return request<T>('GET', path) },
  getPublic<T>(path: string): Promise<T> {
    return fetch(`${getBaseUrl()}${path}`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    }).then(async (response) => {
      if (!response.ok) {
        const errorBody = await response.json().catch(() => ({ message: response.statusText }))
        throw new Error(errorBody?.message || `Request failed: ${response.status}`)
      }
      return response.json() as Promise<T>
    })
  },
  post<T>(path: string, body?: unknown): Promise<T> { return request<T>('POST', path, body) },
  put<T>(path: string, body?: unknown): Promise<T> { return request<T>('PUT', path, body) },
  patch<T>(path: string, body?: unknown): Promise<T> { return request<T>('PATCH', path, body) },
  delete<T>(path: string): Promise<T> { return request<T>('DELETE', path) },
}
